import { required, requiredIf, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      is_config: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
      },
      variants: {
        required: helpers.withMessage(i18n.global.t('Please add at least one variant.'), requiredIf(formState.is_config == true)),
        $each: helpers.forEach({
          modifier_ids: {
          },
        })
      },
      modifier_ids: {
      },
    }
  }
};
